import { createRouter, createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import ProductCategory from '../views/master/ProductCategory.vue' 
import Services from '../views/master/Services.vue'
import ServiceSubscription from '../views/master/servicesubscriptionlist.vue' 
import AddProduct from '../views/product/AddProduct.vue'
import ListProduct from '../views/product/ListProduct.vue'
import PackageView from '../views/package/package.vue'
import CustomerViews from '../views/customer/customer.vue'
import EmployeeView from '../views/customer/employee.vue'
import attendanceView from '../views/customer/attendancelist.vue'
import leadViewss from '../views/lead/lead.vue'
import leadlistview from '../views/lead/leadlist.vue'
import customerlistView from '../views/customer/customerlist.vue'
import addstaffView from '../views/staff/addstaff.vue'
import selectpackageViews from '../views/customer/selectpackage.vue'
import updatesubscriptionView from '../views/customer/updatesubscription.vue'
import accountinglistView from '../views/customer/accountinglist.vue'
import accountlistView from '../views/customer/accountinglist.vue'
import subscriptionlistView from '../views/subscription/subscriptionlist.vue'
import balancereporttView from '../views/balance/balancereport.vue'
import duereport from '../views/balance/duereport.vue'
import FollowupListView from '../views/followup/followuplist.vue'
import stafflistView from '../views/staff/stafflist.vue'
import classesView from '../views/classes/classes.vue'
import classlistView from '../views/classes/classlist.vue'
import addinventaryView from '../views/inventary/addinventary.vue'
import packageExpiryView from '../views/customer/packageexpirylist.vue'
//import serviceExpiryView from '../views/serviceexpiry/serviceexpry.vue'
import totalincomeView from '../views/total/totalincome.vue'
import totaldueView from '../views/total/totaldue.vue'
import staffAccountView from '../views/customer/staffaccountinglist.vue'
import memberDetailsView from '../views/customer/MemberDetails.vue'
import invoicePrintView from '../views/customer/InvoicePrint.vue'
import serviceSubPrintView from '../views/customer/ServiceSubInvoicePrint.vue'

import equpmentmaintainanceView from '../views/inventary/equpmentmaintainance.vue'

import staffinvoiceView from '../views/staff/staffinvoice.vue'
import attendanceReport from '../views/attendanceReport.vue'
import staffAttendance from '../views/staffAttendance.vue'
 
const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: HomeView
  }, 
  {
    path: '/attendanceReport',
    name: 'attendanceReport',
    component: attendanceReport
  },
  {
    path: '/staffAttendance',
    name: 'staffAttendance',
    component: staffAttendance
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'duereport',
    component: duereport
  },
  {
    path: '/invoice/print',
    name: 'InvoicePrint',
    component: invoicePrintView
  },
  {
    path: '/servicesubinvoice/print',
    name: 'ServiceSubPrint',
    component: serviceSubPrintView
  },
  {
    path: '/staffaccount',
    name: 'staffaccount',
    component: staffAccountView
  },
  {
    path: '/employee',
    name: 'employee',
    component: EmployeeView
  },
  {
    path: '/attendancelist',
    name: 'attendancelist',
    component: attendanceView
  },
  {
    path: '/productcategory',
    name: 'productcategory',
    component: ProductCategory
  },
  {
    path: '/member-details',
    name: 'member-details',
    component: memberDetailsView
  },
  {
    path: '/pkgexpiry',
    name: 'pkgexpiry',
    component: packageExpiryView
  },
  {
    path: '/services',
    name: 'services',
    component: Services
  },
  {
    path: '/servicesubscription',
    name: 'servicesubscription',
    component: ServiceSubscription
  },
  {
    path: '/todaysfollowup/:type',
    name: 'todaysfollowup',
    component: FollowupListView
  },
  {
    path: '/package',
    name: 'package',
    component: PackageView
  },
  {
    path: '/customer',
    name: 'customer',
    component: CustomerViews
  },
  {
    path: '/classlist',
    name: 'classlist',
    component: classlistView
  },

  {
    path: '/totalincome',
    name: 'totalincome',
    component: totalincomeView
  },

  {
    path: '/totaldue',
    name: 'totaldue',
    component: totaldueView
  },

  {
    path: '/addinventary',
    name: 'addinventary',
    component: addinventaryView
  },

  {
    path: '/equpmentmaintainance',
    name: 'equpmentmaintainance',
    component: equpmentmaintainanceView
  },


  {
    path: '/classes',
    name: 'classes',
    component: classesView
  },



  {
    path: '/customerlist',
    name: 'customerlist',
    component: customerlistView
  },

  {
    path: '/subscriptionlist/:type',
    name: 'subscriptionlist',
    component: subscriptionlistView
  },


  {
    path: '/selectpackage',
    name: 'selectpackage',
    component: selectpackageViews
  },

  {
    path: '/updatesubscription',
    name: 'updatesubscription',
    component: updatesubscriptionView
  },
  
  {
    path: '/accountinglist',
    name: 'accountinglist',
    component: accountinglistView
  },


{
    path: '/accountlist/:id',
    name: 'accountlist',
    component: accountinglistView
  },


  {
    path: '/lead',
    name: 'lead',
    component: leadViewss
  },


  {
    path: '/addproduct',
    name: 'addproduct',
    component: AddProduct
  },


  {
    path: '/balancereport',
    name: 'abalancereport',
    component: balancereporttView 
  },


  {
    path: '/listproduct',
    name: 'listproduct',
    component: ListProduct
  },


  {
    path: '/stafflist',
    name: 'stafflist',
    component: stafflistView
  },
 
 
  {
    path: '/leadlist',
    name: 'leadlist',
    component: leadlistview
  },
  {
    path: '/addstaff',
    name: 'addstaff',
    component: addstaffView
  },

 {
    path: '/staffinvoice',
    name: 'staffinvoice',
    component: staffinvoiceView
  },


  
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
history: createWebHashHistory(),
  routes
})

export default router
